import type { MetroAnalyticsReporter } from '../interaction/metroAnalyticsReporter'
import type { ConsentDecision, TcfConsent } from '../cookie/tcfConsent'

/**
 * `cookie_consent_chosen { decision, analytics, advertising, first }` — the
 * visitor's answer in the consent window (`src/cookie/consent.ts`):
 *
 * - `decision` — `accepted` (every TCF purpose), `rejected` (none: the ×, or
 *   "Save my choices" untouched) or `customized`;
 * - `analytics` / `advertising` — `accepted | rejected`, what the answer
 *   means for the two consumers (`tcfConsent.ts`);
 * - `first` — `true` for the window the page opened by itself, `false` for
 *   a change made after re-opening it ("Cookie settings").
 *
 * Web-only: the apps ask no such question. The name is kept from the
 * vanilla-cookieconsent banner (2026-10-28, `analytics` + `first` only) so
 * the chart's history continues; `decision` and `advertising` arrived with
 * the TCF window (TASK-1162). A rejection still arrives: Amplitude runs
 * cookieless without consent, and this event carries no identifier.
 */
export function recordConsentChoice(
  reporter: MetroAnalyticsReporter,
  decision: ConsentDecision,
  consent: TcfConsent,
  first: boolean,
): void {
  reporter('cookie_consent_chosen', {
    decision,
    analytics: consent.analytics ? 'accepted' : 'rejected',
    advertising: consent.advertising ? 'accepted' : 'rejected',
    first,
  })
}
